import { FormEvent, useState } from 'react';
import { ArrowRight, Search } from 'lucide-react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ProofStatusCard } from '../components/ProofStatusCard';
import { TrustLayerCard } from '../components/TrustLayerCard';
import { trustLayers } from '../data/trustLayers';
import { useI18n } from '../i18n/useI18n';
import { useSeo } from './useSeo';

export function ProofPage() {
  const { proofId } = useParams();
  const [value, setValue] = useState(proofId ?? '');
  const navigate = useNavigate();
  const { t } = useI18n();
  useSeo('seo.proof.title', 'seo.proof.description');

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    const normalized = value.trim();
    if (normalized) {
      navigate(`/proof/${encodeURIComponent(normalized)}`);
    }
  }

  const verifyUrl = proofId
    ? `https://verify.ddproof.com/proof/${encodeURIComponent(proofId)}`
    : 'https://verify.ddproof.com/';

  return (
    <main>
      <section className="page-hero proof-page">
        <p className="eyebrow">{t('proof.eyebrow')}</p>
        <h1>{t('proof.title')}</h1>
        <p>{t('proof.text')}</p>
        <form className="proof-form" onSubmit={onSubmit}>
          <label htmlFor="proof-id">{t('proof.input')}</label>
          <div>
            <input
              id="proof-id"
              value={value}
              onChange={(event) => setValue(event.target.value)}
              placeholder="df31b81b2dc890eb757992fa94cbf1ba"
            />
            <button type="submit" className="button primary">
              <Search size={18} />
              {t('proof.open')}
            </button>
          </div>
        </form>
        <a className="button secondary" href={verifyUrl}>
          {t('proof.verifyDomain')}
          <ArrowRight size={18} />
        </a>
      </section>
      <section className="section split-section">
        <ProofStatusCard />
        <div>
          <h2>{t('proof.previewTitle')}</h2>
          <p>{t('proof.previewText')}</p>
          <div className="mini-trust-list">
            {trustLayers.slice(0, 3).map((item) => (
              <TrustLayerCard item={item} key={item.id} />
            ))}
          </div>
          <Link className="button ghost" to="/privacy">
            {t('proof.privacy')}
          </Link>
        </div>
      </section>
    </main>
  );
}
